import { render, staticRenderFns } from "./AddPurchaseInvoiceRow.vue?vue&type=template&id=1083a8bf"
import script from "./AddPurchaseInvoiceRow.vue?vue&type=script&lang=ts"
export * from "./AddPurchaseInvoiceRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports